import { render, staticRenderFns } from "./ModalBan.vue?vue&type=template&id=3984daea&scoped=true"
import script from "./ModalBan.vue?vue&type=script&lang=js"
export * from "./ModalBan.vue?vue&type=script&lang=js"
import style0 from "./ModalBan.vue?vue&type=style&index=0&id=3984daea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3984daea",
  null
  
)

export default component.exports